import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../redux/store";
import { RegisterAPI, registerCall } from "./registerAPI";

export interface RegisterState {
  status: "idle" | "registering" | "success" | "failed";
}

const initialState: RegisterState = {
  status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const registerAsync = createAsyncThunk(
  "register/registerCall",
  async (payload: RegisterAPI) => {
    const response = await registerCall(payload);
    return response.data.token;

    // The value we return becomes the `fulfilled` action payload
  },
);

export const registerSlice = createSlice({
  name: "register",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(registerAsync.pending, (state) => {
        state.status = "registering";
      })
      .addCase(registerAsync.fulfilled, (state, action) => {
        localStorage.setItem("token", action.payload);
        state.status = "success";
      })
      .addCase(registerAsync.rejected, (state) => {
        state.status = "failed";
      });
  },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatus = (state: RootState) => state.register.status;

export default registerSlice.reducer;
